import React, { useEffect, useState } from "react";
import { toast } from "sonner";
import { KeyRound, Loader2, Copy } from "lucide-react";
import { api, errMsg } from "@/lib/api";
import { Card } from "@/components/admin/ui";

export function IssueCodes({ onDone }: { onDone: () => void }) {
  const [orgs, setOrgs] = useState<any[]>([]);
  const [orgId, setOrgId] = useState("");
  const [qty, setQty] = useState(1);
  const [note, setNote] = useState("");
  const [busy, setBusy] = useState(false);
  const [result, setResult] = useState<any>(null);
  useEffect(() => { api.get("/admin/organizations").then((r) => setOrgs(r.data.filter((o: any) => o.active !== false && !o.closed))); }, []);
  const submit = async (e: React.FormEvent) => {
    e.preventDefault();
    setBusy(true);
    try {
      const { data } = await api.post("/admin/codes/issue", { org_id: orgId, quantity: qty, note });
      setResult(data);
      toast.success(`Issued ${data.codes.length} code(s) to ${data.org_name}`);
      setNote("");
      onDone();
    } catch (err) { toast.error(errMsg(err)); }
    setBusy(false);
  };
  const copy = () => { navigator.clipboard.writeText(result.codes.map((c: any) => c.code).join("\n")); toast.success("Copied"); };
  return (
    <Card title="Issue new codes" testId="issue-codes-card">
      <form className="space-y-3 p-6" onSubmit={submit}>
        <p className="text-sm text-[#475569]">Create new unused codes for an organization at no charge. For example, test codes or replacements. Nothing is emailed; give the code to whoever needs it.</p>
        <select className="field-input" value={orgId} onChange={(e) => setOrgId(e.target.value)} required data-testid="issue-codes-org-select">
          <option value="">Select organization…</option>
          {orgs.map((o) => <option key={o.id} value={o.id}>{o.name}</option>)}
        </select>
        <div className="flex gap-3">
          <label className="w-28"><span className="field-label">How many</span>
            <input className="field-input" type="number" min={1} max={50} value={qty} onChange={(e) => setQty(Math.max(1, Math.min(50, Number(e.target.value) || 1)))} data-testid="issue-codes-quantity" /></label>
          <label className="flex-1"><span className="field-label">Note (optional)</span>
            <input className="field-input" placeholder="e.g. Test code for Jen" value={note} onChange={(e) => setNote(e.target.value)} maxLength={300} data-testid="issue-codes-note" /></label>
        </div>
        <button className="btn-primary btn-sm" disabled={!orgId || busy} data-testid="issue-codes-submit">
          {busy ? <Loader2 className="h-4 w-4 animate-spin" /> : <KeyRound className="h-4 w-4" />} Issue code{qty > 1 ? "s" : ""}
        </button>
        {result && (
          <div className="rounded-xl bg-[#F0FDFA] p-4 text-sm" data-testid="issue-codes-result">
            <p className="font-semibold text-[#134E4A]">{result.org_name}</p>
            {result.codes.map((c: any) => <p key={c.code} className="mt-1 font-mono text-lg font-bold tracking-wider" data-testid={`issued-code-${c.code}`}>{c.code} <span className="font-sans text-xs font-normal text-[#64748B]">expires {c.expires_at.slice(0, 10)}</span></p>)}
            <button type="button" className="btn-secondary btn-sm mt-3" onClick={copy} data-testid="issue-codes-copy"><Copy className="h-4 w-4" /> Copy</button>
          </div>
        )}
      </form>
    </Card>
  );
}
